<div>
  <div class="avenueAsset-form">
    <form
      novalidate
      [formGroup]="assetForm"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxFlex="100"
      >
      <div class="required">Required *</div>

      <mat-form-field class="avenueAsset-form__title" style="width: 90%">
        <label>
          <input
            matInput
            trimInput
            type="text"
            placeholder="Title"
            formControlName="displayName"
            />
        </label>
        <mat-error
          print-error
          [control]="assetForm.get('displayName')"
          fieldName="Media title"
          >
        </mat-error>
      </mat-form-field>

      <div class="quill-body" fxFlex="90%">
        <text-editor
          placeholder="Description"
          formControlName="description"
        ></text-editor>
      </div>

      @if (activePrograms && activePrograms.length > 0) {
        <mat-form-field
          class="create-form__program"
          >
          <mat-select placeholder="Program" formControlName="languageID">
            <mat-option>--</mat-option>
            @for (program of activePrograms; track program) {
              <mat-option
                [value]="program.subjectId"
                >
                {{ program?.subjectName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field class="create-form__visibility">
        <mat-label>Share With</mat-label>
        <mat-select
          formControlName="visibility"
          >
          @for (opt of visibilityOpts; track opt) {
            <mat-option
              [value]="opt.key"
              >
              {{ opt.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-tab-group>
        <mat-tab label="Upload">
          <div
            class="asset-uploader"
            fxLayout="column"
            fxLayoutAlign="center center"
            >
            <div fxLayout="column" fxLayoutAlign="start">
              <span>File *</span>
              <div class="avenueAsset-form__note">
                File must be an image or video.
              </div>
            </div>
            <div
              ng2FileDrop
              (fileOver)="fileOverBase($event)"
              (onFileDrop)="fileSelected()"
              [uploader]="uploader"
              class="asset-file-dropzone"
              >
              <h2>Drop File Here</h2>
              <p>Or, if you prefer...</p>

              <input
                type="file"
                ng2FileSelect
                placeholder=""
                #fileUploader
                [accept]="getMimeTypes()"
                [uploader]="uploader"
                [hidden]="true"
                (change)="onUploaderChange($event)"
                (onFileSelected)="fileSelected()"
                />

              <button
                id="file-select-button"
                class="file-select-button"
                mat-raised-button
                color="default"
                (click)="fileUploader.click()"
                >
                <mat-icon>folder_open</mat-icon>
                {{
                isIos
                ? "Select File or record a video"
                : "Select File"
                }}
              </button>

              @if (mediaUrl || mediaUrl$) {
                <div
                  class="thumbnail"
                  >
                  @if (mediaType == 1) {
                    <span>
                      @if (mediaUrl) {
                        <img
                          [src]="mediaUrl"
                          alt="Performance Media Image"
                          />
                      }
                      @if (mediaUrl$ && !mediaUrl) {
                        <img
                          [src]="mediaUrl$ | async"
                          alt="Performance Media Image"
                          />
                      }
                    </span>
                  }
                  @if (mediaType == 0) {
                    <span>
                      @if (mediaUrl) {
                        <video
                          class="video"
                          playsinline
                          controls
                          [src]="mediaUrl"
                        ></video>
                      }
                      @if (mediaUrl$) {
                        <video
                          class="video"
                          playsinline
                          controls
                          [src]="mediaUrl$ | async"
                        ></video>
                      }
                    </span>
                  }
                </div>
              }

              <div class="selected-file-name">
                <p>
                  <strong>{{
                    uploader.queue[0]?.file?.name
                  }}</strong>
                  @if (uploader.queue?.length > 0) {
                    <mat-icon
                      class="clear-icon"
                                        (click)="
                                            clearSubmissionSet();
                                            mediaUrl = '';
                                            uploadedFilename = ''
                                        "
                      >clear
                    </mat-icon>
                  }
                  <span class="cdk-visually-hidden"
                    >Clear Performance Submission Icon</span
                    >
                  </p>
                </div>

                <p class="helperText uploaderSupportText">
                  <strong>Supported file types:</strong>jpg, jpeg,
                  png, mp4, webm, mov
                </p>
                <p class="helperText uploaderSupportText">
                  <strong>Max file size:</strong> 64MB
                </p>
              </div>
            </div>
          </mat-tab>

          @if (!isIos) {
            <mat-tab label="Record">
              <avenue-asset-recorder
                (recordedFile)="recordedFileEvent($event)"
              ></avenue-asset-recorder>
            </mat-tab>
          }
        </mat-tab-group>

        @if (showFileProgressBar) {
          <mat-progress-bar
            mode="determinate"
            value="{{ uploader.queue[0]?.progress }}"
            >
          </mat-progress-bar>
        }

        <div>
          <button
            mat-raised-button
            color="default"
            [disabled]="disableUploadBtn"
            (click)="uploadFile()"
            >
            <mat-icon>cloud_upload</mat-icon>
            Upload File
          </button>
        </div>

        <div class="button-set">
          <button
            mat-raised-button
            class="button--cancel"
            (click)="cancelPerformAsset()"
            >
            Cancel
          </button>
          @if (!exists) {
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="createPerformAsset()"
                    [disabled]="
                        !uploadedFilename ||
                        !assetForm.valid ||
                        assetForm.pristine ||
                        (!mediaUrl && !mediaUrl$ && !uploader.queue.length)
                    "
              >
              Add Media
            </button>
          }
          @if (exists) {
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="updatePerformAsset()"
              [disabled]="disableUpdateMediaButton()"
              >
              Update Media
            </button>
          }
        </div>
      </form>
    </div>
  </div>
